import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Flex, Spin } from 'antd';
import LabOrdHistoryCard from './labOrdHistoryCard';
import { fetchLabOrders } from '../../../Redux/actions/orderActions';

function Index({ activeTab }) {
    const { labOrders, isLoading } = useSelector((state) => state.orders);
    const dispatch = useDispatch();
    const loggedUserObj = localStorage.getItem("patientData");
    const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

    useEffect(() => {
        dispatch(fetchLabOrders({patientId: loggedUser?.patientId}));
    }, []);

    return (
        <div>
            {isLoading ? (
                <div className="flex items-center justify-center mt-[10%]">
                    <Flex align="center" gap="middle">
                        <Spin size="large" tip="Loading" />
                    </Flex>
                </div>
            ) : labOrders?.length === 0 ? (
                <div className="flex flex-col items-center justify-center">
                    <p className="font-medium text-xl">No data found!!</p>
                </div>
            ) : (
                <div className="w-full grid grid-cols-2 sm:grid-cols-1 gap-3">
                    {
                        labOrders.map((order, idx) => (
                            <LabOrdHistoryCard key={idx} order={order} />
                        ))
                    }

                </div>
            )}
        </div>
    )
}

export default Index